export const GET_CRYPTO_LIST = "GET_CRYPTO_LIST";
export const GET_CRYPTO = "GET_CRYPTO";
export const POST_CRYPTO = "POST_CRYPTO";
export const UPDATE_CRYPTO = "UPDATE_CRYPTO";
export const DELETE_CRYPTO = "DELETE_CRYPTO";
export const SHOW_CRYPTO = "SHOW_CRYPTO";
export const UPDATE_STATUS_CRYPTO = "UPDATE_STATUS_CRYPTO";